export default "__VITE_ASSET__725d0293__";